import ApiManager from "@/api/ApiManager";

const SET_FLAGS = 'SET_FEATURE_FLAGS';

// initial state — safe defaults so the UI behaves correctly before the API call resolves.
const state = {
  useQualifyingEarnings: false,
  qualifyingEarningsCutoverDate: '2026-07-01T00:00:00Z',
  requireSsid: false,
  sspProvider: 'Ozedi',
  // "Ozedi" when employers pay super through OZEDI, "None" when they download the SAFF file.
  superProvider: 'None',
  loaded: false,
};

const getters = {
  useQualifyingEarnings: state => state.useQualifyingEarnings,
  qualifyingEarningsCutoverDate: state => state.qualifyingEarningsCutoverDate,
  isAfterQualifyingEarningsCutover: state => (paymentDate) => {
    if (!paymentDate) return false;
    return new Date(paymentDate) >= new Date(state.qualifyingEarningsCutoverDate);
  },
  shouldShowQualifyingEarnings: state => (paymentDate) => {
    if (!state.useQualifyingEarnings) return false;
    if (!paymentDate) return false;
    return new Date(paymentDate) >= new Date(state.qualifyingEarningsCutoverDate);
  },
  requireSsid: state => state.requireSsid,
  // SSID is mandatory for STP whenever the kill-switch is on, regardless of payment date
  // (mirrors the server-side gate in STPReportController.SendATO).
  isSsidRequired: state => () => !!state.requireSsid,
  sspProvider: state => state.sspProvider,
  isSuperThroughOzedi: state => state.superProvider === 'Ozedi',
  // An SSID only works with the SSP that issued it, so after a switch an old one doesn't count
  // (mirrors CompanyStp.HasSsidFrom). SSIDs stored before the issuer was recorded came from MessageXchange.
  hasSsidFromActiveSsp: state => (companySTP) =>
    !!companySTP?.ssid && (companySTP.ssidProvider || 'MessageXchange') === state.sspProvider,
};

const actions = {
  fetchFeatureFlags({ commit }) {
    return new Promise((resolve, reject) => {
      ApiManager.get("/api/Home/FeatureFlags")
        .then((res) => {
          // ApiManager.get returns the decrypted response BODY object itself (ResponseData => Ok(data)),
          // so the flags are at the root of `res` — not under res.data.
          const data = res ?? {};
          commit(SET_FLAGS, data);
          resolve(data);
        })
        .catch((err) => {
          // Leave defaults in place; resolve so app continues to function.
          console.warn('Failed to load feature flags, using defaults:', err);
          resolve(state);
        });
    });
  },
};

const mutations = {
  [SET_FLAGS](state, flags) {
    if (flags.useQualifyingEarnings !== undefined) state.useQualifyingEarnings = flags.useQualifyingEarnings;
    if (flags.qualifyingEarningsCutoverDate) state.qualifyingEarningsCutoverDate = flags.qualifyingEarningsCutoverDate;
    if (flags.requireSsid !== undefined) state.requireSsid = flags.requireSsid;
    if (flags.sspProvider) state.sspProvider = flags.sspProvider;
    if (flags.superProvider) state.superProvider = flags.superProvider;
    state.loaded = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
